<template>
  <div class="field">
    <label style="display: block; margin-bottom: 15px;" :class="isFieldRequired ? 'req' : ''">{{ label }}</label>
    <p class="field_description" v-if="description">{{ description }}</p>
    <input
        :disabled="isDataUpdated"
        :class="isFieldHasError ? 'has_errors':''"
        name="name"
        type="number"
        :value="modelValue"
        @focus="onFocus"
        @input="$emit('update:modelValue', $event.target.value)"
        @change="$emit('onChange', $event.target.value);"
    />
  </div>
</template>

<script>
export default {
  name: "BaseInput3Num.vue",
  data() {
    return {
    }
  },
  mounted() {
  },
  props: [
    'label',
    'modelValue',
    'description',
    'rules',
    'objectKey',//Нужен для валидации
    'isFormSubmitted',
    'isDataUpdated'
  ],
  methods: {
    onFocus() {
      if (!this.modelValue) {
        this.$emit('update:modelValue', '')
      }
    }
  },
  computed: {
    isFieldRequired() {
      if (this.objectKey) {
        return this.$parent.isFieldRequired(this.objectKey);
      }
      return false;
    },
    isFieldHasError() {
      return !!(this.isFieldRequired && this.isFormSubmitted && (this.modelValue === undefined || this.modelValue.length === 0));
    }
  }

}
</script>

<style scoped>
.field_description {
  font-size: 13px;
}
</style>